(()=>{
  const root=document.querySelector('[data-tc-home]');
  const rail=root?.querySelector('[data-terrain-stage]');
  if(!rail||!matchMedia('(max-width:760px)').matches)return;
  const cards=[...rail.querySelectorAll('.tc-terrain-card')];
  const count=root.querySelector('[data-terrain-mobile-count]');
  const dots=[...root.querySelectorAll('.tc-terrain-mobile-dots i')];
  const arrowPattern=/↗️|⤴️|[↗➚🔗]/gu;
  const cleanText=node=>{
    const value=node.nodeValue||'';
    arrowPattern.lastIndex=0;
    if(arrowPattern.test(value))node.nodeValue=value.replace(arrowPattern,'').replace(/\s{2,}/g,' ');
    arrowPattern.lastIndex=0;
  };
  const cleanElement=node=>{
    if(!(node instanceof Element))return;
    const elements=[node,...node.querySelectorAll('*')];
    elements.forEach(element=>{
      const marker=`${element.className||''} ${element.getAttribute?.('aria-label')||''} ${element.getAttribute?.('title')||''}`.toLowerCase();
      if(/(external-link-icon|outbound-icon|open-new-icon|arrow-up-right)/.test(marker))element.remove();
    });
    const walker=document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
    while(walker.nextNode())cleanText(walker.currentNode);
  };
  const removeInjectedArrows=node=>{
    if(node?.nodeType===Node.TEXT_NODE){cleanText(node);return;}
    cleanElement(node instanceof Element?node:root);
  };
  removeInjectedArrows(root);
  const pendingClean=new Set();
  let cleanFrame=0;
  let frame=0;
  const scheduleClean=node=>{
    pendingClean.add(node);
    if(cleanFrame)return;
    cleanFrame=requestAnimationFrame(()=>{
      cleanFrame=0;
      pendingClean.forEach(item=>{if(item.isConnected!==false)removeInjectedArrows(item)});
      pendingClean.clear();
    });
  };
  const arrowObserver=new MutationObserver(mutations=>mutations.forEach(mutation=>{
    if(mutation.type==='characterData')scheduleClean(mutation.target);
    mutation.addedNodes.forEach(scheduleClean);
  }));
  arrowObserver.observe(root,{childList:true,subtree:true,characterData:true});
  const release=event=>{
    if(event.target!==root&&!event.target?.contains?.(root))return;
    arrowObserver.disconnect();
    if(cleanFrame)cancelAnimationFrame(cleanFrame);
    if(frame)cancelAnimationFrame(frame);
    pendingClean.clear();
    document.removeEventListener('shopify:section:unload',release);
  };
  document.addEventListener('shopify:section:unload',release);
  cards.forEach(card=>{
    const link=card.dataset.terrainLink||card.querySelector('a')?.href;
    if(!link)return;
    card.removeAttribute('role');
    card.removeAttribute('tabindex');
    let startX=0,startY=0,moved=false;
    card.addEventListener('pointerdown',event=>{startX=event.clientX;startY=event.clientY;moved=false},{passive:true});
    card.addEventListener('pointermove',event=>{if(Math.abs(event.clientX-startX)>8||Math.abs(event.clientY-startY)>8)moved=true},{passive:true});
    card.addEventListener('pointercancel',()=>{moved=true},{passive:true});
    card.addEventListener('click',event=>{
      if(moved||Math.abs(event.clientX-startX)>8||Math.abs(event.clientY-startY)>8)return;
      location.href=link;
    });
  });
  let current=-1;
  const setCurrent=index=>{
    if(index===current||index<0||index>=cards.length)return;
    current=index;
    cards.forEach((card,i)=>card.classList.toggle('is-mobile-current',i===index));
    dots.forEach((dot,i)=>dot.classList.toggle('is-current',i===index));
    if(count)count.textContent=`${String(index+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
  };
  setCurrent(0);
  const update=()=>{
    frame=0;
    const center=rail.scrollLeft+rail.clientWidth/2;
    let nearest=0,distance=Infinity;
    cards.forEach((card,index)=>{const d=Math.abs(card.offsetLeft+card.offsetWidth/2-center);if(d<distance){distance=d;nearest=index}});
    setCurrent(nearest);
  };
  rail.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update)},{passive:true});
  rail.addEventListener('keydown',event=>{
    if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();
    const next=Math.max(0,Math.min(cards.length-1,current+(event.key==='ArrowRight'?1:-1)));
    cards[next].scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'nearest',inline:'start'});
  });
})();
